export const DEFAULT_PAGE_SIZE = 40;
export const DEFAULT_FIRST_PAGE = 0;
export const DEFAULT_ORDER_AND_DIRECTION = 'title,asc';
